"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Link } from "@opensea/next-ui-kit";
import { Card, CardContent, CardContentBadge, CardContentMedia, CardFooter, Chip, classNames, NumberDisplay, SpaceBetween, TextBody, TextLabel, TextOverflowTooltip } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useContextSelector } from "use-context-selector";
import { CollectionSettingsContext } from "@/components/collection/CollectionSettingsProvider";
import { getCollectionUrlByTrait } from "@/components/collection/utils";
import { ItemAvatar, ItemAvatarFragment } from "@/components/items/avatar/ItemAvatar";
import { GridItemSkeleton } from "@/components/items/GridItemSkeleton";
import { itemUrl, itemUrlFragment } from "@/components/items/utils";
import { TokenPrice } from "@/components/price/TokenPrice";
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment";
export const CollectionTraitItemsCardFragment = graphql(`
    fragment CollectionTraitItemsCard on CollectionAttributeFlatValue {
      count
      traitType
      traitValue
      percent
      floorPrice {
        pricePerItem {
          ...TokenPrice
        }
      }
      topOffer {
        pricePerItem {
          ...TokenPrice
        }
      }
      previewItems(limit: 5) {
        id
        ...ItemAvatar
        ...itemUrl
      }
    }
  `, [ItemAvatarFragment, TokenPriceFragment, itemUrlFragment]);
const MAX_PREVIEW_ITEMS_COUNT = 4;
export function CollectionTraitItemsCard(t0) {
  const $ = _c(73);
  const {
    item: itemKey,
    context
  } = t0;
  const t = useTranslations("CollectionTraitItemsCard");
  const showRarity = useContextSelector(CollectionSettingsContext, _temp);
  let T0;
  let T1;
  let T2;
  let T3;
  let extraItemsCount;
  let isUnique;
  let item;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== context?.collectionSlug || $[1] !== itemKey) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      item = readFragment(CollectionTraitItemsCardFragment, itemKey);
      if (!item) {
        let t6;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <GridItemSkeleton />;
          $[14] = t6;
        } else {
          t6 = $[14];
        }
        t5 = t6;
        break bb0;
      }
      const previewItems = item.previewItems?.slice(0, item.previewItems.length < MAX_PREVIEW_ITEMS_COUNT ? 1 : MAX_PREVIEW_ITEMS_COUNT);
      extraItemsCount = item.count - (previewItems?.length ?? 0);
      isUnique = item.count === 1;
      T3 = Link;
      t3 = item.previewItems?.length === 1 ? itemUrl(item.previewItems[0]) : getCollectionUrlByTrait(context?.collectionSlug ?? "", {
        traitType: item.traitType,
        values: [item.traitValue]
      });
      t4 = "unstyled";
      T2 = Card;
      T1 = CardContent;
      T0 = CardContentMedia;
      const t6 = previewItems?.length === 1 ? "grid-cols-1" : "grid-cols-2 grid-rows-2";
      if ($[15] !== t6) {
        t1 = classNames("grid", t6, "gap-2");
        $[15] = t6;
        $[16] = t1;
      } else {
        t1 = $[16];
      }
      t2 = previewItems?.map(previewItem => <ItemAvatar item={previewItem} key={previewItem.id} size={previewItems.length === 1 ? 400 : 200} style={{
        width: "100%",
        height: "100%"
      }} />);
    }
    $[0] = context?.collectionSlug;
    $[1] = itemKey;
    $[2] = T0;
    $[3] = T1;
    $[4] = T2;
    $[5] = T3;
    $[6] = extraItemsCount;
    $[7] = isUnique;
    $[8] = item;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    T0 = $[2];
    T1 = $[3];
    T2 = $[4];
    T3 = $[5];
    extraItemsCount = $[6];
    isUnique = $[7];
    item = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[17] !== T0 || $[18] !== t1 || $[19] !== t2) {
    t6 = <T0 className={t1}>{t2}</T0>;
    $[17] = T0;
    $[18] = t1;
    $[19] = t2;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== extraItemsCount || $[22] !== isUnique) {
    t7 = isUnique || extraItemsCount > 0 ? <Chip className="bg-bg-app">{isUnique ? "Unique" : `+${extraItemsCount.toString()}`}</Chip> : null;
    $[21] = extraItemsCount;
    $[22] = isUnique;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t7) {
    t8 = <CardContentBadge active={true}>{t7}</CardContentBadge>;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== T1 || $[27] !== t6 || $[28] !== t8) {
    t9 = <T1>{t6}{t8}</T1>;
    $[26] = T1;
    $[27] = t6;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== item.traitType) {
    t10 = <div><TextLabel color="text-secondary">{item.traitType}</TextLabel></div>;
    $[30] = item.traitType;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== item.traitValue) {
    t11 = <TextOverflowTooltip><TextBody weight="semibold">{item.traitValue}</TextBody></TextOverflowTooltip>;
    $[32] = item.traitValue;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t10 || $[35] !== t11) {
    t12 = <SpaceBetween className="items-center gap-2">{t10}{t11}</SpaceBetween>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== item.percent || $[38] !== showRarity || $[39] !== t) {
    t13 = showRarity && <SpaceBetween className="items-center"><TextLabel color="text-secondary">{t("rarity")}</TextLabel><TextLabel><NumberDisplay custom={{
          maximumSignificantDigits: 2
        }} display="percent" value={item.percent} /></TextLabel></SpaceBetween>;
    $[37] = item.percent;
    $[38] = showRarity;
    $[39] = t;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t) {
    t14 = t("floor");
    $[41] = t;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t14) {
    t15 = <TextLabel color="text-secondary">{t14}</TextLabel>;
    $[43] = t14;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  const t16 = item.floorPrice?.pricePerItem;
  let t17;
  if ($[45] !== t16) {
    t17 = <TextLabel><TokenPrice price={t16} /></TextLabel>;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t15 || $[48] !== t17) {
    t18 = <SpaceBetween className="items-center">{t15}{t17}</SpaceBetween>;
    $[47] = t15;
    $[48] = t17;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== t) {
    t19 = t("bestOffer");
    $[50] = t;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== t19) {
    t20 = <TextLabel color="text-secondary">{t19}</TextLabel>;
    $[52] = t19;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  const t21 = item.topOffer?.pricePerItem;
  let t22;
  if ($[54] !== t21) {
    t22 = <TextLabel><TokenPrice price={t21} /></TextLabel>;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t20 || $[57] !== t22) {
    t23 = <SpaceBetween className="items-center">{t20}{t22}</SpaceBetween>;
    $[56] = t20;
    $[57] = t22;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== t12 || $[60] !== t13 || $[61] !== t18 || $[62] !== t23) {
    t24 = <CardFooter className="flex flex-col gap-1.5 p-3">{t12}{t13}{t18}{t23}</CardFooter>;
    $[59] = t12;
    $[60] = t13;
    $[61] = t18;
    $[62] = t23;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  let t25;
  if ($[64] !== T2 || $[65] !== t24 || $[66] !== t9) {
    t25 = <T2>{t9}{t24}</T2>;
    $[64] = T2;
    $[65] = t24;
    $[66] = t9;
    $[67] = t25;
  } else {
    t25 = $[67];
  }
  let t26;
  if ($[68] !== T3 || $[69] !== t25 || $[70] !== t3 || $[71] !== t4) {
    t26 = <T3 href={t3} variant={t4}>{t25}</T3>;
    $[68] = T3;
    $[69] = t25;
    $[70] = t3;
    $[71] = t4;
    $[72] = t26;
  } else {
    t26 = $[72];
  }
  return t26;
}
function _temp(state) {
  return state.showRarity;
}